<template>
  <v-card
    :loading="initializing"
    :class="{ 'is-fullscreen': isFullscreen, 'dark-mode': useTheme && theme === 'dark' }"
    class="helmi-group-dashboard-card mx-auto"
    :style="`min-height: ${minHeight}`"
    @initialized="initializing = false"
  >
    <v-card-title class="primary--text headline">
      <p class="helmi-card-title mb-0 pb-0" :class="{ 'white--text': useTheme && theme === 'dark'}">
        {{ title }}
      </p>
      <v-spacer/>

      <v-btn
        v-if="themeSwitch"
        color="primary"
        icon
        @click="setChartTheme()"
      >
        <v-icon :color="useTheme && theme === 'dark' ? 'white' : 'accent'">
          settings_brightness
        </v-icon>
      </v-btn>

      <v-btn
        v-if="fullscreen"
        color="primary"
        icon
        @click="isFullscreen = !isFullscreen; resizeCharts()"
      >
        <v-icon :color="useTheme && theme === 'dark' ? 'white' : 'accent'">
          {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-subtitle v-if="subtitle" :class="{ 'white--text': useTheme && theme === 'dark'}">
      {{ subtitle }}
    </v-card-subtitle>

    <slot/>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'GroupDashboardCard',

  props: {
    fullscreen: {
      type: Boolean,
      default: false,
    },

    themeSwitch: {
      type: Boolean,
      default: false,
    },

    useTheme: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: null,
    },

    subtitle: {
      type: String,
      default: null,
    },

    initializing: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: String,
      default: () => 'auto',
    },
  },

  data: () => ({
    isFullscreen: false,
  }),

  computed: {
    ...mapState({
      theme: 'theme',
    }),
  },

  methods: {
    ...mapActions({
      setChartTheme: 'setChartTheme',
    }),
    onInitializing(e) {
      console.log(e);
    },
    resizeCharts() {
      this.$bus.$emit('resizeCharts');
      this.$bus.$emit('fullscreen', this.isFullscreen);
    },
  },
};
</script>

<style lang="scss">
.helmi-group-dashboard-card {
  .chart-height {
    height: 400px;
  }

  &.is-fullscreen {
    z-index: 9999;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .chart-height {
      height: 90vh;
    }
  }

  &.dark-mode {
    background:rgb(16, 12, 42);
  }
}
</style>
